import { useMemo } from 'react'
import { GridOptions } from 'ag-grid-community'
import {
  columnTypes,
  defaultOnCellClicked,
  frameworkComponents,
} from '../../../containers/commons/AgGrid'
import { DefaultCellRenderer } from '../../../containers/BulkSheetView/components/cellRenderer'
import { intl } from '../../../../i18n'
import {
  PROGRAM_PROJECT_REPORT_ROW_TYPE,
  ProgramProjectReportRow,
} from '../model/reportRow'
import { useColumnDefs, statusFilterOptions } from './columnDefs'

export const useProgramProjectReportGridOptions =
  (): GridOptions<ProgramProjectReportRow> => {
    const columnDefs = useColumnDefs()

    return useMemo(
      () => ({
        groupHeaderHeight: 25,
        headerHeight: 45,
        floatingFiltersHeight: 25,
        rowHeight: 32,

        context: {
          programProjectReportTypes: Object.values(
            PROGRAM_PROJECT_REPORT_ROW_TYPE
          ),
          programProjectReportStatuses: statusFilterOptions,
        },

        columnTypes: columnTypes(),
        components: frameworkComponents,
        defaultColGroupDef: { suppressHeaderContextMenu: true },
        defaultColDef: {
          cellDataType: false,
          width: 85,
          editable: false,
          enableValue: false,
          sortable: true,
          resizable: true,
          filter: 'clientSideTextFilter',
          floatingFilter: true,
          suppressHeaderMenuButton: true,
          suppressHeaderContextMenu: true,
          suppressSizeToFit: true,
          cellStyle: { justifyContent: 'left' },
          cellRenderer: DefaultCellRenderer,
          onCellClicked: defaultOnCellClicked,
        },
        columnDefs,

        treeData: true,
        excludeChildrenWhenTreeDataFiltering: true,
        groupDefaultExpanded: -1,
        autoGroupColumnDef: {
          headerName: intl.formatMessage({
            id: 'programProjectReport.column.name',
          }),
          field: 'displayName',
          editable: false,
          sortable: true,
          filter: 'clientSideTextFilter',
          cellRendererParams: {
            suppressCount: true,
          },
          width: 300,
          pinned: 'left' as const,
        },
        processUnpinnedColumns: () => [],
      }),
      [columnDefs]
    )
  }
